import { useEffect, useState } from "react";
import { SliderData } from "../../DataPath/products";
import Carousels from "../../components/Carousels";
import DynamicFlow from "./DynamicFlow";
import ClientScroll from "../../components/clientsscroll/ClientScroll";
import DemoRequestForm from "../../components/Demo/DemoRequestForm";
import Chooseus from "./Whychoose/Chooseus";
import AutomationFlow from "./AutomationFlow/AutomationFlow";
import CTASection from "../Company/CTASection/CTASection";
const Home = () => {
  const [getSliderData, setSliderData] = useState([]);

  useEffect(() => {
    setSliderData(SliderData);
  }, []);

  const handleDemoSubmit = async (event) => {
    event.preventDefault();

    try {
      const formData = new FormData(event.target);

      // Add Web3Forms access key
      formData.append("access_key", "b3e05231-a97f-4182-8c24-be343a2b0119");

      // Convert to JSON
      const object = Object.fromEntries(formData.entries());
      const json = JSON.stringify(object);

      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: json,
      });

      const result = await response.json();

      if (result.success) {
        console.log("✅ Success:", result);

        // Optional: reset form
        event.target.reset();
      } else {
        console.error("❌ Submission failed:", result);
        alert("Submission failed. Please try again.");
      }
    } catch (error) {
      console.error("❌ Error submitting form:", error);
      alert("Something went wrong. Please try again later.");
    }
  };

  return (
    <div>
      <div className="home">
        <Carousels data={getSliderData} />
        <DynamicFlow />
        <Chooseus />
        <AutomationFlow />
        <CTASection />
        <ClientScroll />
        <DemoRequestForm onSubmit={handleDemoSubmit} />
      </div>
    </div>
  );
};
export default Home;
